<template>
  <div>
    <div v-if="!innerIsReview">
      <validation-provider
              v-slot="{ errors }"
              :name="label || 'This'"
              :rules="rules"
              mode="eager"
              v-bind="providerProps"
              v-show="innerShouldShow"
              :vid="'validate-'+fieldAssignmentId"
      >
        <span class="field-directions" v-if="directions" v-html="directions"></span>
        <v-text-field
                v-model="innerValue"
                v-bind="vProps"
                ref="autocomplete"
                :error-messages="errors"
                :prepend-icon="computedIcon"
                hide-details="auto"
        >
        <template #label>
            <span v-if="innerLabel" v-html="innerLabel"></span>
        </template>
      </v-text-field>
      </validation-provider>
    </div>
    <div v-else>
      <type-review
              v-if="extraProps"
              :label="label"
              :directions="directions"
              :should-show="innerShouldShow"
              :show-edit-button="extraProps.editButton"
              :page-number="extraProps.originalPageNumber"
              @goToPage="goToPage($event)"
      >
        <div v-if="innerValue">
          <span v-html="innerValue"></span>
        </div>
        <div v-else>N/A</div>
      </type-review>
    </div>
  </div>
</template>

<script>
  import formMixin from '../formMixin'
  import TypeReview from "./TypeReview";
  import {mapState} from "vuex";

  export default {
    name: 'TypeGooglePlace',
    mixins: [formMixin],
    components:{
      TypeReview
    },
    props: {
      showIcon: {
        type: Boolean,
        default: true,
      },
    },
    data: () => {
      return {
        autocomplete:null,
      }
    },
    methods: {
      getBoundsForAutocomplete() {
        if( this.partnerData && this.partnerData.address ) {
          const self = this;
          let g = new google.maps.Geocoder();
          g.geocode({address:`${this.partnerData.address}`}, (results, status) => {
            if( status == "OK" && results.length ) {
              let bounds = results[0].geometry.bounds;
              if( !bounds )
                bounds = new google.maps.LatLngBounds(results[0].geometry.location);
              self.setUpAutoComplete(bounds);
            } else {
              self.setUpAutoComplete();
            }
          });
        } else {
          this.setUpAutoComplete();
        }
      },
      setUpAutoComplete(bounds=false) {
        const options = {
          fields: [
            "name",
            "geometry.location",
            "place_id",
            "address_components",
            "formatted_address",
            "formatted_phone_number",
            "website",
            "opening_hours"
          ],
          types: [("address", "establishment")]
        };
        if( bounds ) {
          options.bounds = bounds;
          options.rankBy = google.maps.places.RankBy.DISTANCE;
        }

        this.autocomplete = new google.maps.places.Autocomplete(this.$refs.autocomplete?.$refs.input, options);
        this.autocomplete.addListener("place_changed", () => {
          const place = this.autocomplete.getPlace();
          // update structure
          this.innerValue = place.name;
          this.setSiblingValue('fromGoogle', true);

          const paths = this.field_path.split('.');
          if( paths[0] ) {
            this.setSiblingValue(paths[0] +'.latitude', place.geometry.location.lat());
            this.setSiblingValue(paths[0] +'.longitude', place.geometry.location.lng());
            this.setSiblingValue(paths[0] +'.google_place_id', place.place_id);
            this.setSiblingValue(paths[0] +'.phone', place.formatted_phone_number);
            this.setSiblingValue(paths[0] +'.address', place.formatted_address);
            this.setSiblingValue(paths[0] +'.address_components', place.address_components);
            this.setSiblingValue(paths[0] +'.website', place.website);
            this.setSiblingValue(paths[0] +'.hours', place.opening_hours);
            this.setSiblingValue(paths[0] +'.hours_auto_update', 1);
          }
        });
      },
    },
    computed: {
      ...mapState('partner', ['partnerData']),
      defaults() {
        return {
          label: this.innerLabel,
          directions: this.directions,
          persistentHint: true,
        }
      },
      rules() {
        return (this.enableValidation) ? {
          ...this.validation_settings,
          required:!!this.validation_settings.required && !!this.innerShouldShow,
        } : {}
      },
      computedIcon() {
        return this.showIcon ? 'mdi-search' : undefined
      },
    },
    mounted() {
      this.getBoundsForAutocomplete();
      this.fieldLoaded(); // signal to the form we are loaded
    }
  }
</script>
